import {
  ErrorMessage,
  ErrorMessageTitle,
} from '@app/components/error-message/error-message';
import { Spinner } from '@app/components/icons/spinner';
import { State } from '@app/store/state';
import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export const RecordingPage = () => {
  const { recordingRedirectFailed } = useSelector(
    (state: State) => state.contentHub.recordingInfo,
  );

  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center gap-6">
      {recordingRedirectFailed ? (
        <ErrorMessage>
          <ErrorMessageTitle>
            {t('content-hub.recording-not-found')}
          </ErrorMessageTitle>
          <Link to="../../../library">{t('content-hub.back-to-library')}</Link>
        </ErrorMessage>
      ) : (
        <Spinner size="large" theme="dark" />
      )}
    </div>
  );
};
